import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { menuItems } from 'Data/staticDatas';
import { getUserRole } from 'helpers/utis';
import './sidebar.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import {
  faCircleChevronRight,
  faCircleChevronLeft,
  faArrowRightFromBracket
} from '@fortawesome/free-solid-svg-icons';
import { postLogoutAct } from 'redux/actions/requestFieldMasterSetupViewAction';
import { Toast } from 'service/toast';
import { logout } from 'service/utilities';
import { Avatar } from 'components/common/Avatar';
import { ListItem } from './ListItem';

export function Sidebar({ toggle, isOpen, isMobile }) {
  const userInfo = JSON.parse(localStorage.getItem('userData'));
  const userEmail = userInfo?.email || Cookies.get('email') || '';

  const handleLogout = async () => {
    try {
      const res = await postLogoutAct();
      const { success, message } = res;
      if (success) {
        Toast({ type: 'success', message });
        logout();
      } else {
        Toast({ type: 'error', message: message || 'Logout failed' });
      }
    } catch (err) {
      Toast({ type: 'error', message: 'An error occurred during logout.' });
    }
  };

  return (
    <>
      {isMobile ? (
        <div className="custom-mobile-sidebar">
          <div className="menu-mobile-sidebar">
            <ul className="items-container">
              {menuItems?.map((data) => {
                const show = getUserRole(data?.role);
                if (!show) return null;
                return (
                  <ListItem {...data} key={data.title} isMenuOpen={isOpen} />
                );
              })}
            </ul>
          </div>
        </div>
      ) : (
        <div
          className={`custom-sidebar-modern ${
            isOpen ? 'open-sidebar' : 'closed-sidebar'
          }`}
        >
          <div className="menu-container-modern">
            <button type="button" className="toggle-btn" onClick={toggle}>
              <FontAwesomeIcon
                icon={isOpen ? faCircleChevronLeft : faCircleChevronRight}
                className="hamburger-icon"
              />
            </button>
            {isOpen && (
              <Link to="/" className="logo-modern">
                Anchor Lending
              </Link>
            )}
          </div>

          <div className="menu-sidebar-modern">
            <ul className="items-container-modern">
              {menuItems?.map((data) => {
                const show = getUserRole(data?.role);
                if (!show) return null;
                return (
                  <ListItem {...data} key={data.title} isMenuOpen={isOpen} />
                );
              })}
            </ul>

            {/* Profile + Logout */}
            <div className="sidebar-footer">
              {isOpen ? (
                <div className="profile-modern-btn">
                  <Avatar isBig className="sidebar-avatar" />
                  <span className="profile-email" title={userEmail}>
                    {userEmail}
                  </span>
                </div>
              ) : (
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id="tooltip-profile">{userEmail}</Tooltip>}
                  delay={{ show: 100, hide: 50 }}
                >
                  <div className="profile-modern-btn">
                    <Avatar className="sidebar-avatar" />
                  </div>
                </OverlayTrigger>
              )}

              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-logout">Logout</Tooltip>}
                delay={{ show: 100, hide: 50 }}
              >
                <button
                  type="button"
                  className="logout-modern-btn"
                  onClick={handleLogout}
                >
                  <FontAwesomeIcon icon={faArrowRightFromBracket} />
                </button>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

Sidebar.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  isMobile: PropTypes.bool
};

Sidebar.defaultProps = {
  toggle: () => null,
  isOpen: true,
  isMobile: false
};
